export default "__VITE_ASSET__itzm3Pmq__"